<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1>{{$t('modals.create_trajectory.title')}}</h1>
        </div>

        <search-client-form
            v-if="state == 'search'"
            :wrapperClass="['modal__content']"
            @create-client="onSearchResult"
            @found-client="onSearchResult">

            <div slot="header">
                <p>
                    {{$t('forms.search_client.intro_text')}}
                </p>
            </div>

            <div class="modal__footer" slot="buttons" slot-scope="{ isNextDisabled }">
                <div class="actions">
                    <button type="submit" class="actions__action--save pull-right" :class="{disabled: isNextDisabled}" :disabled="isNextDisabled">{{$t('common.next')}}</button>
                    <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </search-client-form>

        <client-form
            v-else-if="state == 'clientform'"
            :wrapperClass="['modal__content']"
            :client="client"
            @saved="onClientSaved">

            <div slot="header">
                <p>
                    {{$t('forms.client.intro_text')}}
                </p>
            </div>

            <div class="modal__footer" slot="buttons" slot-scope="{ isNextDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isNextDisabled}" :disabled="isNextDisabled">{{$t('common.next')}}</button>
                    <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </client-form>

        <trajectory-form
            v-else-if="state == 'trajectoryform'"
            :wrapperClass="['modal__content']"
            :trajectory="trajectory"
            @saved="onTrajectoryCreated">


            <div slot="header">
                <p>
                    {{$t('forms.trajectory.intro_text')}}
                </p>
            </div>

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('modals.create_trajectory.create')}}</button>
                    <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.cancel')}}</button>
                </div>
            </div>
        </trajectory-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import SearchClientForm from '@/components/forms/dashboard/SearchClientForm';
    import ClientForm from '@/components/forms/dashboard/ClientForm';
    import TrajectoryForm from '@/components/forms/dashboard/TrajectoryForm';

    import { Trajectory, Client } from '@/models';

    import { GET_TRAJECTORIES } from '@/store/modules/trajectories';
    import { LOAD_TRAJECTORY_RESOURCES } from '@/store/modules/trajectory-resources';

    @Component({
        components: {
            SearchClientForm,
            ClientForm,
            TrajectoryForm
        }
    })
    export default class TrajectoryCreateModal extends Vue {
        name = 'trajectory-create-modal';

        client;
        trajectory;
        state = 'search';

        trajectory = new Trajectory();
        client = new Client();

        beforeOpen() {
            // Initialize a new trajectory with default values;
            this.trajectory = new Trajectory();
            this.$store.dispatch(LOAD_TRAJECTORY_RESOURCES);
            this.client = new Client();
            this.state = 'search';
        }

        onSearchResult({client, organisation}) {
            this.client = client;
            this.state = 'clientform';
            Vue.set(this.trajectory, 'organisation', organisation);
        }

        onClientSaved(client) {
            this.state = 'trajectoryform';
            Vue.set(this.trajectory, 'client_id', this.client.id);
            // Preselect the first trajectory state and counselor
            Vue.set(this.trajectory, 'trajectory_state', !this.trajectory.trajectory_state && this.states ? this.states[0] : null);
            Vue.set(this.trajectory, 'counselor', !this.trajectory.counselor && this.counselors ? this.counselors[0] : null);
        }

        onTrajectoryCreated(trajectory) {
            this.$notify.success(this.$t('notify.trajectory.add_success'));
            this.$store.dispatch(GET_TRAJECTORIES, {});
            this.$modal.hide(this.name);
        }

        get counselors() {
            return this.$store.state.trajectory_resources.counselors;
        }

        get states() {
            return this.$store.state.trajectory_resources.trajectory_states;
        }
    }

    Vue.component('trajectory-create-modal', TrajectoryCreateModal);
</script>



// WEBPACK FOOTER //
// src/components/modals/trajectories/TrajectoryCreateModal.vue